export const ROW_GUTTER = { xs: 8, sm: 16, md: 24 };

export const CARD_LAYOUT = {
  xs: { span: 20 },
  sm: { span: 20 },
  md: { span: 11 },
  lg: { span: 8 },
  xl: { span: 8 },
  xxl: { span: 8 },
};



// WEBPACK FOOTER //
// ./src/features/people/employees/components/employeeListGrid/EmployeeListConstants.js